export class Login {
    constructor(
        public username: string,
        public company: string,
        public password: string,
        public rememberMe: boolean
    ) { }
}
